import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getPublicMerchantBrandOptions, type PublicOptionResponse } from "./publicOptions.api";

interface UseGetMerchantBrandOptionsReturn {
  merchantBrandOptions: PublicOptionResponse[];
  fetchMerchantBrandOptions: () => Promise<void>;
}

export const useGetMerchantBrandOptions = (): UseGetMerchantBrandOptionsReturn => {
  const [merchantBrandOptions, setMerchantBrandOptions] = useState<PublicOptionResponse[]>([]);
  const { run: runLatestRequest } = useLatestRequest();

  const fetchMerchantBrandOptions = useCallback(async () => {
    try {
      const response = await runLatestRequest(getPublicMerchantBrandOptions);
      if (!response) return;
      setMerchantBrandOptions(response);
    } catch (error) {
      console.error("Failed to fetch merchant brand options:", error);
    }
  }, [runLatestRequest]);

  return {
    merchantBrandOptions,
    fetchMerchantBrandOptions,
  };
};
